import { useEffect, useState } from 'react'
import { FetchModel } from 'src/services'
import { isDefined } from 'src/types'
import { NOT_RUNNING, RUNNING, STREAMING } from '../../model.utils'

type UseLatestValueTimeRange = {
  from: number
  to: number
}

export function useLatestValueTimeRange(): UseLatestValueTimeRange {
  const [timeRange, setTimeRange] = useState({
    from: Date.now() - 5 * 60 * 1000,
    to: Date.now(),
  })

  useEffect(() => {
    const interval = setInterval(() => {
      setTimeRange({
        from: Date.now() - 5 * 60 * 1000,
        to: Date.now(),
      })
    }, 60_000)

    return () => clearInterval(interval)
  }, [])

  return timeRange
}

export const modelEvaluationStates = [NOT_RUNNING, RUNNING, STREAMING]

export function hasModelEvaluationData(model: FetchModel): boolean {
  if (!model.activeTrainedModel) return false
  const hasVariationData =
    !!model.activeTrainedModel.targetStdHealth &&
    isDefined(model.activeTrainedModel.targetStd)
  const hasForecastData =
    !!model.activeTrainedModel.valRSquareHealth &&
    isDefined(model.activeTrainedModel.valRSquare)
  const hasPotentialImprovement =
    !!model.activeTrainedModel.targetMaeReductionHealth &&
    isDefined(model.activeTrainedModel.targetMaeReduction)
  return hasVariationData || hasForecastData || hasPotentialImprovement
}
